// extracted by mini-css-extract-plugin
module.exports = {"container":"_3XR1Bc_1","content":"_1pXgWJgA"};